// Dad's port-of-call list from his own notes, with coordinates added.
// Each ship's deployments are ordered as he listed them.

export const VOYAGES = [
  {
    ship: "HMS Centaur",
    slug: "hms-centaur",
    dates: "October 1963 – October 1965",
    color: "var(--c-accent)", // brass
    ports: [
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK" },
      { name: "SS Lakonia recovery", lat: 33.5, lng: -16.5, country: "off Madeira", note: "22 Dec 1963 — Centaur diverted to the Greek cruise ship Lakonia (often misspelled 'Laconia'), on fire in the Atlantic about 180 miles north of Madeira. Dad's ship recovered the dead from the sea." },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "", note: "25 Dec 1963 — Christmas Day. Centaur landed the bodies of the Lakonia dead — sewn into canvas in the old naval manner — ashore at Gibraltar." },
      { name: "Suez Canal", lat: 30.5852, lng: 32.2728, country: "Egypt", note: "Transit." },
      { name: "Mombasa", lat: -4.0435, lng: 39.6682, country: "Kenya" },
      { name: "Crossed the Equator", lat: 0, lng: 55, country: "Indian Ocean", note: "Crossing-the-line ceremony." },
      { name: "Singapore", lat: 1.3521, lng: 103.8198, country: "" },
      { name: "Subic Bay", lat: 14.7943, lng: 120.2718, country: "Philippines" },
      { name: "Hong Kong", lat: 22.3193, lng: 114.1694, country: "" },
      { name: "Pulau Tioman", lat: 2.7917, lng: 104.1667, country: "Malaysia" },
      { name: "Singapore", lat: 1.3521, lng: 103.8198, country: "", second: true },
      { name: "Aden", lat: 12.7855, lng: 45.0187, country: "Yemen" },
      { name: "Mombasa", lat: -4.0435, lng: 39.6682, country: "Kenya", second: true },
      { name: "Aden", lat: 12.7855, lng: 45.0187, country: "Yemen", second: true },
      { name: "Madras", lat: 13.0827, lng: 80.2707, country: "India" },
      { name: "Singapore", lat: 1.3521, lng: 103.8198, country: "", third: true },
      { name: "Aden", lat: 12.7855, lng: 45.0187, country: "Yemen", third: true },
      { name: "Suez Canal", lat: 30.5852, lng: 32.2728, country: "Egypt", second: true, note: "Return transit." },
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK", second: true },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "" },
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "" },
      { name: "Naples", lat: 40.8518, lng: 14.2681, country: "Italy" },
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "", second: true },
      { name: "Istanbul", lat: 41.0082, lng: 28.9784, country: "Turkey" },
      { name: "Izmir", lat: 38.4192, lng: 27.1287, country: "Turkey" },
      { name: "Palmas Bay", lat: 39.0167, lng: 8.5333, country: "Sardinia, Italy" },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "", second: true },
      { name: "Lisbon", lat: 38.7223, lng: -9.1393, country: "Portugal" },
      { name: "Belfast", lat: 54.5973, lng: -5.9301, country: "Northern Ireland" },
      { name: "Liverpool", lat: 53.4084, lng: -2.9916, country: "UK" },
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK", third: true },
    ],
  },
  {
    ship: "HMS Hampshire",
    slug: "hms-hampshire",
    dates: "August 1967 – May 1969",
    color: "var(--c-accent-bright)", // light brass
    ports: [
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK" },
      { name: "Devonport", lat: 50.3777, lng: -4.1869, country: "UK" },
      { name: "Rosyth", lat: 56.0285, lng: -3.4500, country: "Scotland" },
      { name: "Malmö", lat: 55.6044, lng: 13.0038, country: "Sweden" },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "" },
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "" },
      { name: "Naples", lat: 40.8518, lng: 14.2681, country: "Italy" },
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "", second: true },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "", second: true },
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK", second: true },
      { name: "Barbados", lat: 13.1132, lng: -59.5988, country: "" },
      { name: "Panama Canal", lat: 9.0817, lng: -79.6839, country: "Panama", note: "Transit." },
      { name: "Callao", lat: -12.0565, lng: -77.1181, country: "Peru" },
      { name: "Valparaíso", lat: -33.0472, lng: -71.6127, country: "Chile" },
      { name: "Cape Horn", lat: -55.9833, lng: -67.2667, country: "Chile", note: "The southern tip of South America — a rare passage for any Royal Navy sailor." },
      { name: "Buenos Aires", lat: -34.6037, lng: -58.3816, country: "Argentina" },
      { name: "Rio de Janeiro", lat: -22.9068, lng: -43.1729, country: "Brazil" },
      { name: "Gibraltar", lat: 36.1408, lng: -5.3536, country: "", third: true },
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK", third: true },
    ],
  },
  {
    ship: "HMS Bulwark",
    slug: "hms-bulwark",
    dates: "May 1972 – January 1974",
    color: "var(--c-accent-dim)", // darker brass
    ports: [
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "" },
      { name: "Caribbean", lat: 17.0, lng: -75.0, country: "" },
      { name: "Miami", lat: 25.7617, lng: -80.1918, country: "USA" },
      { name: "Portsmouth", lat: 50.8198, lng: -1.0880, country: "UK" },
      { name: "Malta", lat: 35.8989, lng: 14.5146, country: "", second: true },
      { name: "Piraeus", lat: 37.9420, lng: 23.6464, country: "Greece" },
      { name: "Istanbul", lat: 41.0082, lng: 28.9784, country: "Turkey" },
      { name: "Travemünde", lat: 53.9606, lng: 10.8753, country: "Germany" },
      { name: "Lübeck", lat: 53.8654, lng: 10.6866, country: "Germany" },
      { name: "Dutch Caribbean", lat: 12.1696, lng: -68.9900, country: "Curaçao" },
      { name: "Cartagena", lat: 10.3910, lng: -75.4794, country: "Colombia" },
      { name: "Montevideo", lat: -34.9011, lng: -56.1645, country: "Uruguay" },
      { name: "Plymouth", lat: 50.3755, lng: -4.1427, country: "UK" },
    ],
  },
];

// Flatten all ports into a single list for the map, tagged with their ship.
export const ALL_PORTS = VOYAGES.flatMap((v) =>
  v.ports.map((p, i) => ({
    ...p,
    ship: v.ship,
    slug: v.slug,
    dates: v.dates,
    color: v.color,
    leg: i + 1,
  }))
);

// Unique port count (collapse repeats by name)
export const UNIQUE_PORT_COUNT = new Set(ALL_PORTS.map((p) => p.name)).size;
